export default __webpack_public_path__ + "static/project5-3f2ebb01e05fa5e63204cfc7e79336be.jpg";